export default __webpack_public_path__ + "static/media/hide.336f1b02.svg";